enum ReservationTimeType {
  MINUTE_15 = "MINUTE_15",
  MINUTE_30 = "MINUTE_30",
  MINUTE_60 = "MINUTE_60",
  MINUTE_90 = "MINUTE_90",
  MINUTE_120 = "MINUTE_120",
}

export default ReservationTimeType;
